import router from '.'

router.beforeEach(({ meta }, from, next) => {
  document.title = meta.title
  next();
})



// WEBPACK FOOTER //
// ./src/router/permission.js